import request from '@/utils/request'

const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API_C
// const VUE_APP_BASIC_DATA_API = 'http://10.166.2.23:3000/mock/36/'
/**
* 获取图片验证码（C端）
*/
export function getGraphic(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}login/getGraphic?platformSource=H5`,
    method: 'get',
    data
  })
}

/**
* 获取短信验证码（C端）
*/
export function getSms(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}login/getSmsH5`,
    method: 'post',
    data
  })
}

/**
* 登录（C端）
*/
export function login(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}login/userLoginAdd`,
    method: 'post',
    data
  })
}

/**
* 登出（C端）
*/
export function logout(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}logout`,
    method: 'post',
    data
  })
}

// 同意个人信息共享条款
export function saveAgreement(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}protocolManage/customer/saveAgreement`,
    // url: 'http://10.166.2.23:3000/mock/36/protocolManage/customer/saveAgreement',
    method: 'post',
    data
  })
}
// 用户代理登录
export function loginuser(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}login/wx-ciam?mobile=${data}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/loginToC.js